const getClientId = (origin) => {
	switch (origin) {
		case "https://gitdash.cfdata.org":
			return "341ff3595c666ac5b0fa161b4ca9c4d9968af79fa5da25d41d8b6305e12b012a";
		case "https://gitlab.ryan-schachte.com":
		case "http://localhost:3000":
		case "http://localhost:3333":
			return "0bacb6bdf3dd4a2095f795febd5cf439f4983f6315e7e2313b9e89d9754cce2f";
		default:
			return "1ecb5d595f30aaeafeb4e49f922821461f9443f5226efcc0deca08819e86e88d";
	}
};

export const GITLAB_CLIENT_ID = getClientId(window.location.origin);
export const GITLAB_BASE_URL = "https://gitlab.cfdata.org";
export const GITLAB_API_URL = `${GITLAB_BASE_URL}/api/v4`;
export const GITLAB_GRAPHQL_URL = `${GITLAB_BASE_URL}/api/graphql?remove_deprecated=true`;
export const AI_CODE_REVIEWER_USERNAME = "gsa_claude";
export const MURLOC_REVIEWER_USERNAME = "gsa_murloc";
export const ITEMS_PER_PAGE = 10;
export const REFRESH_INTERVAL = 2 * 60 * 1000;

// View mode options for the dashboard
export const VIEW_MODE = Object.freeze({
	STANDARD: "standard",
	SWIMLANE: "swimlane",
	REVIEW_BOARD: "reviewboard",
	REPO: "repo",
});

export const DIFF_VIEWER_PRESENTATION = Object.freeze({
	FULLSCREEN: "fullscreen",
	MODAL: "modal",
});

export const DIFF_VIEWER_PRESENTATION_STORAGE_KEY =
	"gitlab-diff-view-presentation";
export const DIFF_VIEWER_PRESENTATION_SELECTED_STORAGE_KEY =
	"gitlab-diff-view-presentation-user-selected";
export const DIFF_OPEN_IN_NEW_WINDOW_STORAGE_KEY =
	"gitlab-diff-open-in-new-window";
